import { render } from "./CustomerTestimonials.vue?vue&type=template&id=1036c83c&scoped=true"
import script from "./CustomerTestimonials.vue?vue&type=script&lang=js"
export * from "./CustomerTestimonials.vue?vue&type=script&lang=js"

import "./CustomerTestimonials.vue?vue&type=style&index=0&id=1036c83c&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1036c83c"]])

export default __exports__